import FormatService from '../format-service';
import { COLORS } from '../../constants/system/colors';

const PLUGIN_ID_PIE_CHART_DATA_LABELS: string = 'pieChartDataLabels';
const TEXT_BASELINE_MIDDLE: string = 'middle';
const LABEL_RENDER_THRESHOLD: number = 0.05;

const ChartPluginPieChartDataLabels = {
  id: PLUGIN_ID_PIE_CHART_DATA_LABELS,
  afterDatasetsDraw(chart: ChartInstance): void {
    const {
      ctx: context,
      data: {
        datasets,
      },
    } = chart;

    const chartData: ChartData = chart.getDatasetMeta(0).data;

    chartData.forEach((chartDataPoint: ChartDataPoint, chartDataPointIndex: number): void => {
      const { x, y } = chartDataPoint.getCenterPoint(true);

      const value: string = datasets[0].data[chartDataPointIndex];
      const totalValue: number = datasets[0].data.reduce((resultValue: number, value: string): number => (
        resultValue + FormatService.parseFloat(value)
      ));

      const textX: number = x - (context.measureText(value).width / 2);
      const formatter: Function = (label: string): string => `${label}%`;

      if (FormatService.parseFloat(value) / totalValue > LABEL_RENDER_THRESHOLD) {
        context.textBaseline = TEXT_BASELINE_MIDDLE;
        context.fillStyle = COLORS.white;
        context.fillText(formatter(datasets[0].data[chartDataPointIndex]), textX, y);
      }
    });
  },
};

export default ChartPluginPieChartDataLabels;
